import { render } from "./tw-slot.vue?vue&type=template&id=ba86c1ec"
import script from "./tw-slot.vue?vue&type=script&lang=js"
export * from "./tw-slot.vue?vue&type=script&lang=js"
script.render = render

export default script